import {AxiosInstance, AxiosPromise, AxiosRequestConfig} from 'axios';
export interface ICustomerInfoResponse {
    customer_no: number;
    customer_id: string;
    customer_name: string;
    company_no: number;
    company_name: string;
}

export const enum ERROR {
    HTTP_API_DEFAULT = 1,
    SET_EXTERNAL_API_DEFAULT,
    SET_OWN_API_DEFAULT,
}

export interface CustomAxiosRequestConfig extends AxiosRequestConfig {
    withUniqueCanceler?: boolean
}
export interface CustomAxiosInstance extends AxiosInstance {
    post<T = any>(url: string, data?: any, config?: CustomAxiosRequestConfig): AxiosPromise<T>;
    /** Do not use this function _post (for custom)*/
    _post<T = any>(url: string, data?: any, config?: AxiosRequestConfig): AxiosPromise<T>;
}
export interface IAPI {
    own: AxiosInstance;
    adserverAPI: CustomAxiosInstance;
    audience: AxiosInstance;
}

export type API_TYPE = IAPI;
declare module 'vue/types/vue' {
interface Vue {
        $http: API_TYPE;
    }
}